<template>
  <el-dialog
    title="新手向导"
    width="800px"
    :visible.sync="isShow"
    class="wizardSteps"
    @close="isShow = false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div
      style="height: 60vh;display: flex;flex-direction: column;"
      v-if="stepData.stepList[stepData.action - 1]"
    >
      <el-steps :active="stepData.action - 1">
        <el-step
          v-for="(item, index) of stepData.stepList"
          :key="index"
          :title="`步骤 ${index + 1}`"
        ></el-step>
      </el-steps>
      <template>
        <img
          class="wizardSteps-media"
          :src="this.osg.downloadUrl + stepData.stepList[stepData.action - 1].fileids[0]"
          alt=""
          v-if="fileType(stepData.stepList[stepData.action - 1].fileids[0]) == 'img'"
        />
        <video
          class="wizardSteps-media"
          v-if="fileType(stepData.stepList[stepData.action - 1].fileids[0]) == 'video'"
          :src="this.osg.downloadUrl + stepData.stepList[stepData.action - 1].fileids[0]"
          controls="controls"
        >
          您的浏览器不支持视频播放
        </video>
      </template>
      <div style="margin-top:4px;padding-bottom: 20px;">
        <!-- <span v-if="stepData.stepList.length">
          {{ stepData.action }}/{{ stepData.stepList.length }}
        </span> -->
        {{ stepData.stepList[stepData.action - 1].title }}
      </div>
    </div>
    <div slot="footer">
      <div class="c-flex c_flex_between">
        <div>
          <el-button v-show="stepData.action != 1" @click="stepChange(0)">上一步</el-button>
        </div>
        <div>
          <el-button
            type="primary"
            @click="stepChange(1)"
            v-if="this.stepData.action != this.stepData.stepList.length"
          >
            下一步
          </el-button>
          <el-button type="primary" @click="isShow = false" v-else>关闭</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  props: {
    colName: {
      type: String
    },
    show: {
      type: Boolean
    }
  },
  data() {
    return {
      stepData: { action: 1, stepList: [] },
      isShow: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let list = await this.getDocumentCategory();
      for (let item of list) {
        //删除开头斜杠
        let action = item.exts ? this.removeSlash(item.exts.action || '') : '';
        if (action == this.removeSlash(this.colName || '')) {
          this.stepData.stepList = await this.getDocument(item._id);
          this.isShow = this.show;
        }
      }
    },
    //删除斜杠
    removeSlash(str) {
      return str.charAt(0) == '/' ? str.substr(1) : str;
    },
    //获取菜单
    getDocumentCategory() {
      return new Promise(resolve => {
        this.osg.ajax('documentCategory/query.do', { type: 7, _all: 1 }, res => {
          resolve((res.entity && res.entity.childrens) || []);
        });
      });
    },
    //根据菜单id获取文档
    getDocument(categoryId) {
      return new Promise(resolve => {
        var params = {
          'is:type|integer#and': 7,
          'is:categoryId|string#and': categoryId,
          sortField: 'createTime',
          sortOrder: 'desc',
          _all: 1
        };
        this.osg.ajax('document/query.do', params, res => {
          resolve(res.data);
        });
      });
    },
    //步骤按钮
    stepChange(state) {
      if (!state) {
        if (this.stepData.action != 1) this.stepData.action--;
      } else {
        if (this.stepData.action != this.stepData.stepList.length) this.stepData.action++;
      }
    },
    //解析文件后缀
    fileType(fileUrl) {
      // 取出文件后缀名
      let suffixArr = fileUrl.split('.');
      let fileSuffix = suffixArr[suffixArr.length - 1];
      const imgList = ['tiff', 'png', 'jpg', 'jpeg', 'bmp', 'gif'];
      const videoList = [
        'wmv',
        'asf',
        'asx',
        'rm',
        'rmvb',
        'mp4',
        '3gp',
        'mov',
        'm4v',
        'avi',
        'dat',
        'mkv',
        'flv',
        'vob',
        'm2v',
        'mp3',
        'wav'
      ];

      if (imgList.indexOf(fileSuffix) > -1) return 'img';
      if (videoList.indexOf(fileSuffix) > -1) return 'video';
    }
  },
  watch: {
    isShow(newVal) {
      if (newVal === false) this.$emit('closeWizard');
    }
  }
};
</script>
<style lang="scss">
.wizardSteps-media {
  width: 100%;
  // height: 50vh;
  object-fit: contain;
  border-radius: 0;
  padding: 20px;
  box-sizing: border-box;
}
</style>
